import './index.css';
import './public-path';
// import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
// import { initTokenFromCookie } from 'services/auth';
import App from './App';

// initTokenFromCookie();

const container = document.getElementById('root');
const root = createRoot(container);
root.render(<App />);
